const BRANDS = [
  { src: "/assets/brands/nautilus.png", alt: "Nautilus" },
  { src: "/assets/brands/paramount.png", alt: "Paramount" },
  { src: "/assets/brands/cybex.png", alt: "Cybex" },
  { src: "/assets/brands/flex.png", alt: "Flex Fitness" },
  { src: "/assets/brands/atlantis.png", alt: "Atlantis" },
  { src: "/assets/brands/startrac.png", alt: "Star Trac" },
  { src: "/assets/brands/gymleco.png", alt: "Gymleco" },
  { src: "/assets/brands/granite.png", alt: "Granite Gym Equipment" },
  { src: "/assets/brands/lifefitness.png", alt: "Life Fitness" },
  { src: "/assets/brands/bootybuilder.png", alt: "Booty Builder" },
  { src: "/assets/brands/powergear.png", alt: "Power Gear" },
  { src: "/assets/brands/rexgym.png", alt: "RexGym" },
  { src: "/assets/brands/strengthshop.png", alt: "Strength Shop" },
  { src: "/assets/brands/diamond.png", alt: "Diamond" },
  { src: "/assets/brands/bombafit.png", alt: "BombaFit" },
  { src: "/assets/brands/lifepro.png", alt: "LifePro Nutrition" },
];

function LogoSet() {
  return (
    <div className="flex items-center gap-12 md:gap-16 pr-12 md:pr-16 shrink-0">
      {BRANDS.map((b) => (
        <img
          key={b.alt}
          src={b.src}
          alt={b.alt}
          className="h-8 md:h-10 max-w-[140px] w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-500"
        />
      ))}
    </div>
  );
}

export default function BrandMarquee() {
  return (
    <div
      data-testid="brand-marquee"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[rgba(176,132,51,0.2)] bg-ink/85 backdrop-blur-md py-3 overflow-hidden"
      aria-label="I migliori marchi al mondo"
    >
      <div className="flex w-max animate-marquee">
        <LogoSet />
        <LogoSet />
      </div>
    </div>
  );
}
